export default __webpack_public_path__ + "static/media/planet.d35f92cf.gif";